class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function addDiscountForm() {
    const checkout = drawer.querySelector('.drawer__footer > .cart__ctas');
    if (!checkout || drawer.querySelector('#shopde-cart-discount')) return;

    checkout.insertAdjacentHTML('afterend', `
      <form id="shopde-cart-discount" class="shopde-cart-discount">
        <label for="shopde-discount-code">Rabattcode</label>
        <div class="shopde-cart-discount__row">
          <input id="shopde-discount-code" type="text" autocomplete="off" required>
          <button type="submit">Einlösen</button>
        </div>
        <p class="shopde-cart-discount__message" role="status" aria-live="polite"></p>
      </form>
    `);
  }

  addDiscountForm();
  new MutationObserver(addDiscountForm).observe(drawer, {
    childList: true,
    subtree: true
  });

  drawer.addEventListener('submit', async (event) => {
    if (event.target.id !== 'shopde-cart-discount') return;
    event.preventDefault();

    const form = event.target;
    const code = form.querySelector('input').value.trim();
    if (!code) return;

    const button = form.querySelector('button');
    const message = form.querySelector('[role="status"]');
    button.disabled = true;
    message.textContent = 'Rabattcode wird geprüft …';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          discount: code,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname + window.location.search
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      const cart = await response.json();
      if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) {
        throw new Error('Cart sections missing');
      }

      drawer.renderContents(cart);
      addDiscountForm();

      const updatedForm = drawer.querySelector('#shopde-cart-discount');
      updatedForm.querySelector('input').value = code;
      updatedForm.querySelector('[role="status"]').textContent =
        'Code übermittelt. Bitte Rabatt und Gesamtpreis prüfen; die endgültige Prüfung erfolgt im Checkout.';
    } catch (error) {
      message.textContent =
        'Rabatt konnte nicht bestätigt werden. Bitte Gesamtpreis oder Checkout prüfen.';
    } finally {
      const currentButton = drawer.querySelector('#shopde-cart-discount button');
      if (currentButton) currentButton.disabled = false;
    }
  });
})();
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function moveCartExtras() {
    const items = drawer.querySelector('cart-drawer-items:not(.is-empty)');
    const footer = drawer.querySelector('.drawer__footer');
    if (!items || !footer) return;

    const shipping = footer.querySelector(':scope > .cart-drawer-shipping-info');
    const note = footer.querySelector(':scope > #Details-CartDrawer');

    if (shipping) items.append(shipping);
    if (note) items.append(note);
  }

  moveCartExtras();
  new MutationObserver(moveCartExtras).observe(drawer, {
    childList: true,
    subtree: true
  });
})();
(() => {
  const root = window.Shopify?.routes?.root || '/';

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#shopde-cart-page-discount');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('input[name="discount"]');
    const message = form.querySelector('[role="status"]');
    const code = input.value.trim();

    if (!code) {
      message.textContent = 'Bitte einen Rabattcode eingeben.';
      input.focus();
      return;
    }

    message.textContent = 'Rabattcode wird angewendet …';

    const cartPath = root + 'cart';
    const redirectPath =
      cartPath + '?discount_attempt=' + encodeURIComponent(code);
    const discountPath =
      root + 'discount/' + encodeURIComponent(code);

    window.location.assign(
      discountPath + '?redirect=' + encodeURIComponent(redirectPath)
    );
  });

  async function showDiscountResult() {
    const url = new URL(window.location.href);
    const attemptedCode = url.searchParams.get('discount_attempt');

    if (!attemptedCode) return;

    const form = document.querySelector('#shopde-cart-page-discount');
    if (!form) return;

    const input = form.querySelector('input[name="discount"]');
    const message = form.querySelector('[role="status"]');

    input.value = attemptedCode;
    message.textContent = 'Rabattcode wird geprüft …';

    try {
      const response = await fetch(root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await response.json();

      const applications = Array.isArray(
        cart.cart_level_discount_applications
      )
        ? [...cart.cart_level_discount_applications]
        : [];

      for (const item of cart.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) {
          if (allocation.discount_application) {
            applications.push(allocation.discount_application);
          }
        }
      }

      const normalizedCode = attemptedCode
        .trim()
        .toLocaleLowerCase('de-DE');

      const applied = applications.some((discount) => {
        return String(discount.title || '')
          .trim()
          .toLocaleLowerCase('de-DE') === normalizedCode;
      });

      message.textContent = applied
        ? 'Rabattcode wurde angewendet.'
        : 'Dieser Rabattcode ist ungültig oder kann für diesen Warenkorb nicht angewendet werden.';
    } catch (error) {
      message.textContent =
        'Der Rabattcode konnte nicht geprüft werden. Bitte erneut versuchen.';
    } finally {
      url.searchParams.delete('discount_attempt');

      const remainingQuery = url.searchParams.toString();
      const cleanUrl =
        url.pathname +
        (remainingQuery ? '?' + remainingQuery : '') +
        url.hash;

      window.history.replaceState({}, '', cleanUrl);
    }
  }

  showDiscountResult();
})();